import { useId, type ReactNode } from 'react';
import type { RemixiconComponentType } from '@remixicon/react';
import { CardTitle } from '../ui';

/**
 * A card of the creation form, of the « Configuration » and « Kubernetes »
 * tabs (mockups « F1 » and « U1 », 2026-10-16): a bordered surface with its
 * header — the shared card header `CardTitle` (« T1 », 2026-10-19). `title`
 * may be a node (the toggle of a collapsible card); the section is named by
 * it either way.
 */
export function SectionCard(props: {
  title: ReactNode;
  children?: ReactNode;
  description?: ReactNode;
  /** The glyph of the header's tile, from `waadooIcons`. */
  icon?: RemixiconComponentType;
  level?: 2 | 3 | 4;
  /** After the heading, on its line (a badge, a summary). */
  aside?: ReactNode;
  /** The heading's id, when something else points at it (focus, a group). */
  titleId?: string;
  /** Focusable heading (`tabIndex={-1}`), to move the focus to on a change. */
  focusableTitle?: boolean;
  /** The hairline under the header; off while the card's body is folded. */
  divider?: boolean;
  className?: string;
}) {
  const generatedId = useId();
  const titleId = props.titleId ?? generatedId;
  return (
    <section
      className={['waadoo-section-card', props.className]
        .filter(Boolean)
        .join(' ')}
      aria-labelledby={titleId}
    >
      <CardTitle
        title={props.title}
        icon={props.icon}
        description={props.description}
        aside={props.aside}
        level={props.level ?? 3}
        titleId={titleId}
        focusableTitle={props.focusableTitle}
        divider={props.divider}
      />
      {props.children}
    </section>
  );
}
